// extracted by mini-css-extract-plugin
module.exports = {"root":"WebinarPageSection_root__ygkdL","header":"WebinarPageSection_header__Wfu_9","title":"WebinarPageSection_title__cl5ZT","main":"WebinarPageSection_main__QiuvT"};